import type { BigliettoEvento } from './tipi';

/**
 * Lo stato della fattura di un ordine del sito, per la scheda Biglietti.
 *
 * "In creazione" e' il segno messo prima di chiamare Fatture in Cloud: se
 * dura piu' di qualche minuto, o c'e' un errore, l'esito e' incerto e va
 * controllato su Fatture in Cloud prima di fare qualsiasi cosa (rifarla
 * potrebbe creare una seconda fattura).
 */
export type StatoFattura =
  | { stato: 'nessuna' }
  | { stato: 'gratuito' }
  | { stato: 'da_fare' }
  | { stato: 'errore'; testo: string }
  | { stato: 'in_creazione' }
  | { stato: 'incerta'; testo: string }
  | { stato: 'emessa'; numero: string | null; id: string }
  | { stato: 'nota_di_credito'; numero: string | null; id: string };

/** Oltre questo tempo una fattura "in creazione" e' un esito incerto (la funzione aspetta FIC al massimo 30 secondi). */
export const MINUTI_PRIMA_DI_INCERTA = 2;

const PAGATI = ['processing', 'completed'];

export function statoFattura(ordine: Pick<BigliettoEvento['ordine'], 'stato' | 'totale' | 'fattura'>, adesso: Date): StatoFattura {
  const f = ordine.fattura;
  if (f.id && !f.annullata) {
    return PAGATI.includes(ordine.stato)
      ? { stato: 'emessa', numero: f.numero, id: f.id }
      : { stato: 'nota_di_credito', numero: f.numero, id: f.id };
  }
  if (f.avviata_at) {
    const minuti = (adesso.getTime() - new Date(f.avviata_at).getTime()) / 60_000;
    if (f.errore || minuti > MINUTI_PRIMA_DI_INCERTA) {
      return {
        stato: 'incerta',
        testo: f.errore ?? 'Fatture in Cloud non ha confermato: controlla lì se la fattura esiste prima di rifarla.',
      };
    }
    return { stato: 'in_creazione' };
  }
  if (!PAGATI.includes(ordine.stato)) return { stato: 'nessuna' };
  // Il biglietto gratis (Visitatore): niente da fatturare, la funzione lo rifiuterebbe.
  if (ordine.totale !== null && ordine.totale <= 0) return { stato: 'gratuito' };
  if (f.errore) return { stato: 'errore', testo: f.errore };
  return { stato: 'da_fare' };
}
